import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StatusSidebarRefreshService {
  private _refreshTrigger = signal(0);

  readonly refreshTrigger = this._refreshTrigger.asReadonly();

  triggerRefresh(): void {
    this._refreshTrigger.update((trigger) => trigger + 1);
  }
}
